/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { HomeComponent } from './components/home/home.component'
import { LoginComponent } from './components/login/login.component'
import { ThreedComponent } from './components/threed/threed.component'
import { DataStatusComponent } from './components/data-status/data-status.component'
import { AuthService } from './services/auth/auth.service'
import { ProfileComponent } from './components/profile/profile.component'
import { DatamanagerComponent } from './components/datamanager/datamanager.component'

const routes: Routes = [
    { path: 'app/home', component: HomeComponent },
    { path: 'app/login', component: LoginComponent },
    { path: 'app/3d', component: ThreedComponent, canActivate: [AuthService] },
    { path: 'app/datastatus', component: DataStatusComponent, canActivate: [AuthService] },
    { path: 'app/profile', component: ProfileComponent, canActivate: [AuthService] },
    { path: 'app/datamanager', component: DatamanagerComponent, canActivate: [AuthService] },
    { path: '', redirectTo: 'app/home', pathMatch: 'full' },
    { path: '**', redirectTo: 'app/home', pathMatch: 'full' },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
